module.exports = __webpack_public_path__ + "static/media/icon_add_disabled.4463593e.svg";